import { InternalError } from './internal.error';

const WORK_EMAIL_REQUIRED_ERROR_CODE = 'work_email_required';
const WORK_EMAIL_REQUIRED_MESSAGE = 'Please provide a work email';

type InviteEmployerMemberError = {
  code?: string;
  message?: string;
};

export class InviteRequiresWorkEmailError extends InternalError {
  constructor(email: string, status?: number | null) {
    super('Invite requires work email', {
      status,
      data: { email },
    });
  }
}

export function isInviteRequiresWorkEmailError(responseData: unknown): boolean {
  const inviteError = getInviteEmployerMemberError(responseData);

  return (
    inviteError.code === WORK_EMAIL_REQUIRED_ERROR_CODE ||
    inviteError.message === WORK_EMAIL_REQUIRED_MESSAGE
  );
}

function getInviteEmployerMemberError(responseData: unknown): InviteEmployerMemberError {
  if (typeof responseData !== 'object' || responseData === null) {
    return {};
  }

  const inviteError: InviteEmployerMemberError = {};

  if ('code' in responseData && typeof responseData.code === 'string') {
    inviteError.code = responseData.code;
  }

  if ('message' in responseData && typeof responseData.message === 'string') {
    inviteError.message = responseData.message;
  }

  return inviteError;
}
